module.exports = __webpack_public_path__ + "static/CRS_03_new-b9a59dac2abd9627b631c2f61a12f73c.svg";